import {getFeedbackUrl} from "../config/stageConfigs";

export type FeedbackKind = 'ThumbsUp' | 'ThumbsDown';

export type FeedbackPayload = {
    user_alias: string;
    feedback: FeedbackKind;
    user_notes: string[] | string | null;
    question_text: string;
    answer_text: string;
    identifier: string;
};

export async function postFeedback(payload: FeedbackPayload): Promise<void> {
    const resp = await fetch(getFeedbackUrl(),
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        },
    );

    if (!resp.ok) {
        const text = await resp.text().catch(() => '');
        throw new Error(`saveUserFeedbackData failed (${resp.status}): ${text}`);
    }
}